module.exports = __webpack_public_path__ + "static/media/1017126.b06b8c10.png";